import { Injectable } from '@angular/core';
import { Usecase } from '../../../../domain/usecase/usecase.interface';
import { AuthRepository } from '../../../../domain/repositories/auth.repository';
import { Result } from '../../../../domain/models/http-response.model';

@Injectable({ providedIn: 'root' })
export class LoginUsecase
  implements
    Usecase<
      { email: string; password: string },
      Promise<
        Result<
          {
            token: string;
          },
          any
        >
      >
    >
{
  constructor(private authRepository: AuthRepository) {}

  execute(credentials: { email: string; password: string }) {
    return this.authRepository.login(credentials.email, credentials.password);
  }
}
